module.exports = __webpack_public_path__ + "static/media/Niveau_elN8_3_897474.cf3a0b4d.png";